import { ProgressSelectors } from '@web_opxp/features';
import { FC } from 'react';
import { connect } from 'react-redux';
import { SKELETON_CLASSNAME, SKELETON_DUMMYTEXT } from '../base/constants';
import { SessionSelectors } from '../session';
import { IState } from '../store/state';
import EstimationExhausted from './components/EstimationExhausted';
import GameplayToReachNextLevelIfSelectedNotMaxReached from './components/GameplayToReachNextLevelIfSelectedNotMaxReached';
import GameplaysToLevelUp from './components/GameplaysToLevelUp';
import HighscoreComparison from './components/HighscoreComparison';
import PredictorWidget from './components/PredictorWidget';
import * as Selectors from './selectors';
import { isInValidRange, normalizeExpectedRemainingGameplays } from './utils';

export interface ISuccessPredictorOwnProps {
  difficulty: number;
  limitDifficulty: number;
  maxDifficulty: number;
}

export interface ISuccessPredictorProps extends ISuccessPredictorOwnProps {
  expectedRemainingGameplaysForLevelUp: number;
  loading: boolean;
}

export const SuccessPredictorFC: FC<ISuccessPredictorProps> = ({
  difficulty,
  expectedRemainingGameplaysForLevelUp,
  limitDifficulty,
  loading,
  maxDifficulty,
}) => {
  if (loading) {
    return (
      <PredictorWidget title={SKELETON_DUMMYTEXT} description={SKELETON_DUMMYTEXT} customClass={SKELETON_CLASSNAME} />
    );
  }
  if (limitDifficulty === maxDifficulty) {
    return <HighscoreComparison />;
  }
  // expectedRemainingGameplaysForLevelUp must be between 0 and MAX_PREDICTOR_GAMEPLAYS
  if (isInValidRange(expectedRemainingGameplaysForLevelUp)) {
    if (difficulty < maxDifficulty) {
      return <GameplayToReachNextLevelIfSelectedNotMaxReached />;
    }
    if (expectedRemainingGameplaysForLevelUp === 0) {
      return <EstimationExhausted />;
    }
    return <GameplaysToLevelUp expectedRemainingGameplaysForLevelUp={expectedRemainingGameplaysForLevelUp} />;
  }
  return <HighscoreComparison />;
};

export const mapStateToProps = (state: IState, ownProps: ISuccessPredictorOwnProps) => {
  const workoutId = SessionSelectors.getActiveWorkoutId(state);
  const loading = Selectors.workoutPredictionIsLoading(state, workoutId);
  const completionCount = ProgressSelectors.getCompletionCountForLevel(state, workoutId, ownProps.maxDifficulty);
  const avgGameplaysForLevelUpAllUsers = Selectors.getCalculatedAvgGameplaysForLevelUp(
    state,
    workoutId,
    ownProps.maxDifficulty
  );
  const expectedRemainingGameplaysForLevelUp = normalizeExpectedRemainingGameplays(
    avgGameplaysForLevelUpAllUsers,
    completionCount
  );
  return {
    loading,
    expectedRemainingGameplaysForLevelUp,
  };
};

const SuccessPredictor = connect(mapStateToProps)(SuccessPredictorFC);
export default SuccessPredictor;
